<script lang="ts">
  type Props = {
    color: string
    size?: number
  }

  let { color, size = 1 }: Props = $props()
</script>

<span
  style={`--color: var(--color-picker-${color}); --size: ${size}rem`}
  class="color"
  aria-label={color}
></span>

<style lang="scss">
  .color {
    display: block;
    min-width: var(--size);
    min-height: var(--size);
    width: var(--size);
    height: var(--size);
    background: var(--color);
    border-radius: 0.125rem;
  }
</style>
